<!--
  - Copyright (c) 2020 GanttProject Cloud OU
  -->

<template>
    <div>
        <div class="d-flex align-items-center">
            <h5 class="m-0">{{ resource.name }}</h5>
            <span v-if="resource.role !== ''"
                  class="ml-2 badge badge-pill badge-secondary">{{ resource.role }}</span>
            <div class="flex-fill"></div>
        </div>
        <small>{{ resource.email }}, {{ resource.phone }}</small>
    </div>
</template>

<script lang="ts">
  import {Vue, Component, Prop} from 'vue-facing-decorator';
  import {ResourceDto} from '../Teams';

  @Component
  export default class ResourceItem extends Vue {
    @Prop()
    public resource: ResourceDto;
  }
</script>
